var _rect, _rect2, _rect3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.672799,
    y: 1.0185,
    width: 36.8589,
    height: 36.8589,
    rx: 4.5274,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.672799,
    y: 1.0185,
    width: 36.8589,
    height: 36.8589,
    rx: 4.5274,
    stroke: "#DEDFEC",
    strokeWidth: 0.945207
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_993_3004",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 7,
    width: 25,
    height: 25
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.87158,
    y: 7.44824,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_993_3004)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1216 21.1982H20.6216V19.6982H13.1216V21.1982ZM13.1216 18.1982H24.6216V16.6982H13.1216V18.1982ZM13.1216 15.1982H24.6216V13.6982H13.1216V15.1982ZM9.37158 28.4867V11.756C9.37158 11.2508 9.54658 10.8232 9.89658 10.4732C10.2466 10.1232 10.6742 9.94824 11.1793 9.94824H26.5638C27.069 9.94824 27.4966 10.1232 27.8466 10.4732C28.1966 10.8232 28.3716 11.2508 28.3716 11.756V23.1405C28.3716 23.6457 28.1966 24.0732 27.8466 24.4232C27.4966 24.7732 27.069 24.9482 26.5638 24.9482H12.9101L9.37158 28.4867ZM12.2716 23.4482H26.5638C26.6408 23.4482 26.7113 23.4162 26.7753 23.352C26.8395 23.288 26.8716 23.2175 26.8716 23.1405V11.756C26.8716 11.679 26.8395 11.6085 26.7753 11.5445C26.7113 11.4803 26.6408 11.4482 26.5638 11.4482H11.1793C11.1023 11.4482 11.0318 11.4803 10.9678 11.5445C10.9037 11.6085 10.8716 11.679 10.8716 11.756V24.833L12.2716 23.4482Z",
    fill: "#667085"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/MessageIcon.7a75eff5ccdcc2176271b5b4f3269685.svg";
export { ForwardRef as ReactComponent };